<template>
  <div>
    <Dropdown>
      <template #button="{ open }">
        <button
          type="button"
          v-if="hasStatus"
          class="text-xs inline-flex px-3 py-1 rounded-full leading-3 text-white bg-gray-600 capitalize focus:outline-none"
          @click="open"
        >
          {{ status || 'no status' }}
        </button>
      </template>
      <template #default="{ close }">
        <ul class="menu">
          <li
            v-for="statusOption in statusOptions"
            :key="statusOption.value"
            class="menu__item text-sm leading-5 hover:bg-gray-200 py-2"
            @click="updateStatus(statusOption.value, close)"
          >
            {{ statusOption.label }}
          </li>
        </ul>
      </template>
    </Dropdown>
  </div>
</template>

<script>
export default {
  props: {
    orderId: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      statusOptions: [
        { value: 'draft', label: 'Draft' },
        { value: 'pending', label: 'Pending' },
        { value: 'in progress', label: 'In progress' },
        { value: 'in review', label: 'In review' },
        { value: 'completed', label: 'Completed' },
      ],
    };
  },
  computed: {
    hasStatus() {
      return typeof this.status === 'string';
    },
  },
  methods: {
    async updateStatus(status, next) {
      try {
        await this.$store.dispatch('ui/orders/updateOrder', {
          orderId: this.orderId,
          params: {
            status,
          },
        });
      } catch (error) {
        //
      } finally {
        next();
      }
    },
  },
};
</script>
